import angular from 'angular';

import SourcesCtrl from './sources.controller';
import SourcesModalConf from './sources.config';

import TruncateFilter from '../../filters/truncate';
import fbOnDelete from '../../directives/fb-on-delete';

import fbUpload from '../../components/fb-upload'

export default angular.module('modals.sources', [SourcesCtrl, fbOnDelete,
    TruncateFilter, fbUpload
  ])
  .run(['$templateCache', ($templateCache) => {
    $templateCache.put('/modals/sources/detail.html', require(
      './partials/detail.html'));
    $templateCache.put('/modals/sources/list-item.box.html', require(
      './partials/list-item.box.html'));
    $templateCache.put('/modals/sources/list-breadcrumb.box.html', require(
      './partials/list-breadcrumb.box.html'));
    $templateCache.put('/modals/sources/list.html', require(
      './partials/list.html'));
    $templateCache.put('/modals/sources/type-nav.html', require(
      './partials/type-nav.html'));
    $templateCache.put('/modals/sources/detail.box.html', require(
      './partials/detail.box.html'));
    $templateCache.put('/modals/sources/detail.dropbox.html', require(
      './partials/detail.dropbox.html'));
    $templateCache.put('/modals/sources/detail.clio.html', require(
      './partials/detail.clio.html'));
    $templateCache.put('/modals/sources/detail.file.html', require(
      './partials/detail.file.html'));
    $templateCache.put('/modals/sources/detail.link.html', require(
      './partials/detail.link.html'));
    $templateCache.put('/modals/sources/detail.note.html', require(
      './partials/detail.note.html'));
    $templateCache.put('/modals/sources/detail.person.html', require(
      './partials/detail.person.html'));
    $templateCache.put('/modals/sources/detail.worksite.html', require(
      './partials/detail.worksite.html'));
  }])
  .constant('SourcesModalConf', SourcesModalConf)
  .name;



// WEBPACK FOOTER //
// ./project/modals/sources/index.js